import React, { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import ClearIcon from '@mui/icons-material/Clear';
import CurrencyIcon from '@mui/icons-material/AttachMoney';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LoadingButton from "@mui/lab/LoadingButton";
import { Card, Tab,Radio,RadioGroup, Tabs,Stack, TextField,FormControl,FormLabel,FormControlLabel,IconButton, InputLabel,MenuItem,Select,InputAdornment,Skeleton, Box } from "@mui/material";

import Datastore from "../../../store/hoa-datastore";
import config from "../../../hoa-config";
import ReportedViolationModal from "./hoa-property-reported-violation-modal";
import HoaPropertyViolationStagesModal from "./hoa-property-violation-stages-list";
import HoaDuesModal from "./hoa-dues-modal";
import HoaPropertyViolationDeleteListItem from "./hoa-property-violation-delete-list-item";

const PropertyViolationDetails = ({
	view,
	propertyData,
	setPropertyData,
	onChangeText,
	violationList,
	setViolationLists,
	hoaDueList,
	setHoaDueLists,
	isViolationLoading,
	setViolationLoading,
	violationError,
	setViolationError,
	isHoaDueLoading,
	files,
	setFiles,
	parentViolationList,
	reorderedViolations,
	setReorderedViolations
}: any) => {
	const [parentViolationBeforeAddingNewStage, setParentViolationBeforeAddingNewStage] = useState(false);
	const [isAddOrUpdateModalOpen, setIsAddOrUpdateModalOpen] = useState(false);
	const [isViolationStagesModalOpen, setIsViolationStagesModalOpen] = useState(false);
	const [activeTab, setActiveTab] = useState(0);
	const [activeList, setActiveList] = useState([]);
	const [resolvedList, setResolvedList] = useState([]);
	const [violation, setViolation] = useState<any>({});
	const [updateIndex, setUpdateIndex] = useState(null);
	const [hoaDue, setHoaDue] = useState<any>({});
	const [activeHoaDueList, setActiveHoaDueList] = useState([]);
	const [resolvedHoaDueList, setResolvedHoaDueList] = useState([]);

	useEffect(() => {
		setActiveList(parentViolationList.filter((value: any) => value.noticeStatus !== "resolved") || [])
		setResolvedList(parentViolationList.filter((value: any) => value.noticeStatus !== 'active')|| [])
	},[parentViolationList, violation])

	useEffect(() => {
		setActiveHoaDueList(hoaDueList.filter((value: any) => value.noticeStatus !== "resolved") || [])
		setResolvedHoaDueList(hoaDueList.filter((value: any) => value.noticeStatus !== 'active')|| [])
	},[hoaDueList, hoaDue])
	
	const handleChange = (e: any, type: string) => {
		onChangeText(e, type);
	};

	const Wheel =(e: any) => {
        e.target.blur();
    }

	const handleAddModalClose = () => {
		setIsAddOrUpdateModalOpen(false);
	}

	const handleViolationStagesModalClose = () => {
		setIsViolationStagesModalOpen(false);
	}

	const addNewBtnClick = () => {
		setViolation({});
		setParentViolationBeforeAddingNewStage(false);
		setIsAddOrUpdateModalOpen(true);
	}

	const onUpdateClick = (item: any) => {
		violationList.forEach((thisViolation:any, index: number) => {
			if (thisViolation.objectId === item.objectId) {
				setUpdateIndex(index);
			}
		});
		const violationCopy = JSON.parse(JSON.stringify(violation));
		violationCopy.violationNoticeFiles = violation.violationNoticeFiles;
		const itemCopy = JSON.parse(JSON.stringify(item));
		itemCopy.violationNoticeFiles = item.violationNoticeFiles;
		setParentViolationBeforeAddingNewStage(violationCopy);
		setViolation(itemCopy);
		setIsAddOrUpdateModalOpen(true);
	}

	const addNewStageBtnClick = () => {
        setParentViolationBeforeAddingNewStage(JSON.parse(JSON.stringify(violation)));
        setIsAddOrUpdateModalOpen(true);
    }

	const onCloseViolationStageModal = () => {
		setIsViolationStagesModalOpen(false);
	}

	const updateAllNoticeStatus = (noticeStatus:any) => {
		const violationCopy = JSON.parse(JSON.stringify(violation));
		const violationListCopy = JSON.parse(JSON.stringify(violationList));

		violationCopy.noticeStatus = noticeStatus;
		setViolation(violationCopy);

		for (const item of violationListCopy) {
			if (item.objectId === violationCopy.objectId) {
				item.noticeStatus = noticeStatus;
			}
		}

		if (Array.isArray(violationCopy.childViolationIdsList) && violationCopy.childViolationIdsList.length > 0) {
			for (const item of violationListCopy) {
				if (violationCopy.childViolationIdsList.includes(item.objectId)) {
					item.noticeStatus = noticeStatus;
				}
			}
		}

		setViolationLists(violationListCopy);
	}

	return (
		<Stack direction={{ xs: "column", sm: "column", md: "row" }}>
			{
				activeTab === 0 ?
					<>
						<HoaPropertyViolationStagesModal
							isViewOnly={false}
							addNewStageBtnClick={addNewStageBtnClick}
							updateAllNoticeStatus={updateAllNoticeStatus}
							onViolationStageClick={onUpdateClick}
							isViolationStagesModalOpen={isViolationStagesModalOpen}
							setIsViolationStagesModalOpen={setIsViolationStagesModalOpen}
							violationList={violationList}
							setViolationLists={setViolationLists}
							violation={violation}
							onCloseViolationStageModal={onCloseViolationStageModal}
							setviolation={setViolation}
							reorderedViolations={reorderedViolations}
							setReorderedViolations={setReorderedViolations}
						/>
						<ReportedViolationModal 
							propertyData={propertyData}
							open={isAddOrUpdateModalOpen}
							handleClose={handleAddModalClose}
							parentViolationBeforeAddingNewStage={parentViolationBeforeAddingNewStage}
							setParentViolationBeforeAddingNewStage={setParentViolationBeforeAddingNewStage}
							updateIndex={updateIndex}
							setUpdateIndex={setUpdateIndex}
							violation={violation}
							setViolation={setViolation}
							violationError={violationError}
							setViolationError={setViolationError}
							violationList={violationList}
							setViolationLists={setViolationLists}
						/>
					</>
					: 
					<HoaDuesModal
						propertyData={propertyData} 
						open={isAddOrUpdateModalOpen}
						handleClose={handleAddModalClose}
						updateIndex={updateIndex}
						setUpdateIndex={setUpdateIndex}
						hoaDue={hoaDue}
						setHoaDue={setHoaDue}
						hoaDueList={hoaDueList}
						setHoaDueLists={setHoaDueLists}
					/>
			}
			<Stack
				flex={1}
				padding={"24px"}
				flexWrap={"wrap"}
				direction={"column"}
				borderRight={"1px solid #E8E8E8"}
			>
				<span className="overview-title-text">Basic Information</span>
				<Stack flexWrap={"wrap"} direction={"row"}>
					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						label={"Violation Fee Outstanding"}
						InputLabelProps={{ style: { fontSize: "14px" } }}
						variant="standard"
						type={"number"}
						value={propertyData.hoaPropertyDetails.violationFeeOutstanding || ""}
						name="violationFeeOutstanding"
						onChange={(e) => handleChange(e, "hoaPropertyDetails")}
						onWheel={e => Wheel(e)}
						disabled
						InputProps={{
						endAdornment :(
							<InputAdornment position="end">
								<CurrencyIcon />
							</InputAdornment>
					)}}/>
					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						label={"Total Violation"}
						InputLabelProps={{ style: { fontSize: "14px" } }}
						variant="standard"
						type={"number"}
						value={propertyData.hoaPropertyDetails.totalViolation || ""}
						name="totalViolation"
						disabled
						onChange={(e) => handleChange(e, "hoaPropertyDetails")}
						onWheel={e => Wheel(e)}
					/>

					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						label={"Avg. Violation/Yearly"}
						InputLabelProps={{ style: { fontSize: "14px" } }}
						variant="standard"
						type={"number"}
						value={propertyData.hoaPropertyDetails.avgViolation || ""}
						name="avgViolation"
						onChange={(e) => handleChange(e, "hoaPropertyDetails")}
						onWheel={e => Wheel(e)}
						InputProps={{
							endAdornment :(
								<InputAdornment position="end">
									<CurrencyIcon />
								</InputAdornment>
					)}}/>
					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						label={"No. of Violation/Yearly"}
						InputLabelProps={{ style: { fontSize: "14px" } }}
						variant="standard"
						type={"number"}
						value={propertyData.hoaPropertyDetails.numberOfViolation || ""}
						name="numberOfViolation"
						onChange={(e) => handleChange(e, "hoaPropertyDetails")}
						onWheel={e => Wheel(e)}
					/>
					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						label={"Invoices Outstanding"}
						InputLabelProps={{ style: { fontSize: "14px" } }}
						variant="standard"
						type={"number"}
						value={propertyData.hoaPropertyDetails.invoicesOutstanding || ""}
						name="invoicesOutstanding"
						onChange={(e) => handleChange(e, "hoaPropertyDetails")}
						onWheel={e => Wheel(e)}
						disabled
						InputProps={{
						endAdornment :(
							<InputAdornment position="end">
								<CurrencyIcon />
							</InputAdornment>
					)}}/>
					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						label={"Total Invoices"}
						InputLabelProps={{ style: { fontSize: "14px" } }}
						variant="standard"
						type={"number"}
						value={propertyData.hoaPropertyDetails.totalInvoices || ""}
						name="totalInvoices"
						disabled
						onChange={(e) => handleChange(e, "hoaPropertyDetails")}
						onWheel={e => Wheel(e)}
					/>

					<span className="overview-title-text" style={{
						width: "100%",
						marginTop: "24px", 
					}}>Master HOA</span>

					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						name="assesmentFee"
						value={propertyData.hoaPropertyDetails.assesmentFee || ""} 
						variant="standard"
						type={"number"}
						onChange={(e) => handleChange(e, "hoaPropertyDetails")} 
						onWheel={e => Wheel(e)}
						label={"Assessment Fee"} 
						InputLabelProps={{style:{fontSize:"14px"}}}
						InputProps={{
						endAdornment :(
							<InputAdornment position="end">
								<CurrencyIcon />
							</InputAdornment>
					)}}/>

					<FormControl
						style={{ width: "226px", marginTop: "17px", marginRight: "17px" }}
						variant="standard"
					>
						<InputLabel className="select-label">Assessment Fee Frequency</InputLabel>
						<Select
							label="Assessment Fee Frequency"
							name="assesmentFeeFrequency"
							endAdornment={
								propertyData.hoaPropertyDetails.assesmentFeeFrequency &&
								<InputAdornment position="end">
									<ClearIcon 
										style={{ paddingRight: '20px', cursor: 'pointer' }}
										onClick={() => {
											const event = {
												target:{
													name:'assesmentFeeFrequency',
													value: ''
												}
											}
											handleChange(event, "hoaPropertyDetails");
										}} 
									/>
								</InputAdornment>
							}
							onChange={(e: any) => {
								handleChange(e, "hoaPropertyDetails");
							}}
							value={propertyData.hoaPropertyDetails.assesmentFeeFrequency || ""}
							style={{ padding: "5.5px 0px" }}
						>
							{config.frequencyOptions.map((option: string) => {
								return (
									<MenuItem key={`key ${option}`} value={option}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					<span className="overview-title-text" style={{
						width: "100%",
						marginTop: "24px", 
					}}>Sub HOA</span>

					<TextField
						style={{
							padding: "10px 0px",
							width: "226px",
							marginRight: "17px",
							marginTop: "17px",
						}}
						name="assessmentFeeSubHoa"
						value={propertyData.hoaPropertyDetails.assessmentFeeSubHoa || ""} 
						variant="standard"
						type={"number"}
						onChange={(e) => handleChange(e, "hoaPropertyDetails")} 
						onWheel={e => Wheel(e)}
						label={"Assessment Fee"} 
						InputLabelProps={{style:{fontSize:"14px"}}}
						InputProps={{
						endAdornment :(
							<InputAdornment position="end">
								<CurrencyIcon />
							</InputAdornment>
					)}}/>

					<FormControl
						style={{ width: "226px", marginTop: "17px", marginRight: "17px" }}
						variant="standard"
					>
						<InputLabel className="select-label">Assessment Fee Frequency</InputLabel>
						<Select
							label="Assessment Fee Frequency"
							name="assessmentFeeFrequencySubHoa"
							endAdornment={
								propertyData.hoaPropertyDetails.assessmentFeeFrequencySubHoa &&
								<InputAdornment position="end">
									<ClearIcon 
										style={{ paddingRight: '20px', cursor: 'pointer' }}
										onClick={() => {
											const event = {
												target:{
													name:'assessmentFeeFrequencySubHoa',
													value: ''
												}
											}
											handleChange(event, "hoaPropertyDetails");
										}} 
									/>
								</InputAdornment>
							}
							onChange={(e: any) => {
								handleChange(e, "hoaPropertyDetails");
							}}
							value={propertyData.hoaPropertyDetails.assessmentFeeFrequencySubHoa || ""}
							style={{ padding: "5.5px 0px" }}
						>
							{config.frequencyOptions.map((option: string) => {
								return (
									<MenuItem key={`key ${option}`} value={option}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Stack>
			</Stack>

			<Stack
				padding={"24px"}
				flexWrap={"wrap"}
				direction={"column"}
				borderRight={"1px solid #E8E8E8"}
				flex={1}
			>
				<div style={{display:'flex', justifyContent:'space-between'}}>
					<Tabs
						value={activeTab}
						onChange={(event, value) => {
							setActiveTab(value);
						}}
					>
						{["Violations", "Invoices"]
							.map((title: string, index: number) => {
								return (
									<Tab
										key={index}
										label={title}
										value={index}
										style={{ minWidth: "143px", textTransform: "none" }}
									/>
								);
							})
							.filter((value:any) => value !== undefined)}
					</Tabs>
					<LoadingButton
						onClick={() => addNewBtnClick()}
						style={{ width: "117px", height: "40px", textTransform: "capitalize" }}
						startIcon={<AddIcon color="primary" />}
						variant="outlined"
						className="text-3E3E3E-14px"
					>
						Add New
					</LoadingButton>
				</div>
				
				<Stack
					style={{
						height: window.innerHeight - Datastore.responsiveHeightWithtab - 56 - 120,
						overflowY: "scroll",
					}}
					marginTop={"32px"}
					direction={"column"}
				>
					{
						activeTab === 0 ?
						<>
						<span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Active`}</span>
						<ListComponent isViolationLoading={isViolationLoading} updateIndex={updateIndex} setUpdateIndex={setUpdateIndex} open={isAddOrUpdateModalOpen} setIsAddOrUpdateModalOpen={setIsAddOrUpdateModalOpen} onCloseHandle={handleAddModalClose} violation={violation} setViolation={setViolation} list={activeList} violationList={violationList} setViolationLists={setViolationLists} setIsViolationStagesModalOpen={setIsViolationStagesModalOpen}/>
						<span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Resolved`}</span>
						<ListComponent isViolationLoading={isViolationLoading} updateIndex={updateIndex} setUpdateIndex={setUpdateIndex} open={isAddOrUpdateModalOpen} setIsAddOrUpdateModalOpen={setIsAddOrUpdateModalOpen} onCloseHandle={handleAddModalClose} violation={violation} setViolation={setViolation} list={resolvedList} violationList={violationList} setViolationLists={setViolationLists} setIsViolationStagesModalOpen={setIsViolationStagesModalOpen}/>
						</>
						:
						<>
						<span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Active`}</span>
						<HoaDueListComponent updateIndex={updateIndex} setUpdateIndex={setUpdateIndex} open={isAddOrUpdateModalOpen} setIsAddOrUpdateModalOpen={setIsAddOrUpdateModalOpen} onCloseHandle={handleAddModalClose} hoaDue={hoaDue} setHoaDue={setHoaDue} list={activeHoaDueList} hoaDueList={hoaDueList} setHoaDueLists={setHoaDueLists}/>
						<span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Resolved`}</span>
						<HoaDueListComponent isHoaDueLoading={isHoaDueLoading} updateIndex={updateIndex} setUpdateIndex={setUpdateIndex} open={isAddOrUpdateModalOpen} setIsAddOrUpdateModalOpen={setIsAddOrUpdateModalOpen} onCloseHandle={handleAddModalClose} hoaDue={hoaDue} setHoaDue={setHoaDue} list={resolvedHoaDueList} hoaDueList={hoaDueList} setHoaDueLists={setHoaDueLists}/>
						</>
					}
				</Stack>
			</Stack>
		</Stack>
	);
};

export default PropertyViolationDetails;

const ListComponent = ({updateIndex, isViolationLoading, setUpdateIndex, isAddOrUpdateModalOpen, setIsAddOrUpdateModalOpen, onCloseHandle, violation, setViolation, list, violationList, setViolationLists, setIsViolationStagesModalOpen}: any) => {
	const onViolationClick = (item:any) => {
		setUpdateIndex(violationList.indexOf(item))
		setViolation(item);
		setIsViolationStagesModalOpen(true);
	}

	const showHoaId = (item: any) => {
        if (Array.isArray(item?.hoaInfo) && item.hoaInfo.length > 0 && item.hoaInfo[0].hoaId) {
            return item.hoaInfo[0].hoaId
        }
        else {
            return "N/A";
        }
    }

	
	if(isViolationLoading){
        return(
            <Stack direction='column' spacing={1}>
                <Skeleton variant="rectangular"  height={92} />
                <Skeleton variant="rectangular"  height={92} />
            </Stack>
        )
    }
	return (
		<Stack>
			{
				list && list.length > 0 ? list.map((item: any, index: number) => {
					if(!item.isDeleted){
						return (
							<Card
								variant="outlined"
								style={{ background: "#FAFAFA" }}
								className="violation-card-container"
							>
								<Stack direction={"row"} justifyContent={'space-between'}>
									<div style={{display:'flex', cursor: 'pointer', width: '100%'}} onClick={()=>onViolationClick(item)}>
										<span style={{marginRight: '12px', color: '#9F9F9F'}}>{index+1}</span>
										<div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
											<Box display="flex" alignItems="center" justifyContent="space-between">
											  <Box>
												<Box style={{ fontSize: '12px', fontWeight: 500 }}>
												  {item.violation}
												</Box>
												<Box style={{ fontSize: '12px', color: '#9F9F9F', paddingTop: '4px' }}>
												  Added On : {item.createdAt ? new Date(item.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'N/A'}
												</Box>
											  </Box>
											
											  {item?.violationType && (
												<Box
												  sx={{
													fontSize: '12px',
													backgroundColor: item.violationType === 'HOA Violation' ? '#e1d1ed' : '#bad9b0',
													px: '8px',
													py: '2px',
													lineHeight: 1.5,
													borderRadius: '4px',
													alignSelf: 'flex-start'
												  }}
												>
												  {item.violationType}
												</Box>
											  )}
											</Box>
											<div style={{display: 'flex', width: '100%', paddingTop: '10px'}}>
												<div style={{display: 'flex', flexDirection: 'column', width: '20%'}}>
													<span style={{fontSize: '12px', fontWeight: 500}} >Hoa ID</span>
													<span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{showHoaId(item)}</span>
												</div>
												<div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
													<span style={{fontSize: '12px', fontWeight: 500}} >Violation ID</span>
													<span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{item.objectId ? `${item.propertyId}-${item.objectId}` : 'N/A'}</span>
												</div>
												<div style={{display: 'flex', flexDirection: 'column', width: '30%'}}>
													<span style={{fontSize: '12px', fontWeight: 500}} >Stage</span>
													<span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{item.stage || 'N/A'}</span>
												</div>
											</div>
										</div>
									</div>
								</Stack>
							</Card>
						)
					}
				}) :
				<Card
					variant="outlined"
					style={{ background: "#FAFAFA" }}
					className="violation-card-container"
				>
					<Stack direction={"row"} justifyContent={'space-between'}>
						<div style={{display:'flex'}}>
							<span style={{marginRight: '12px', color: '#9F9F9F'}}>{`No Item Added Yet !`}</span>
						</div>
					</Stack>
				</Card>
			}
		</Stack>
	)
}

const HoaDueListComponent = ({updateIndex,isHoaDueLoading, setUpdateIndex, isAddOrUpdateModalOpen, setIsAddOrUpdateModalOpen, onCloseHandle, hoaDue, setHoaDue, list, hoaDueList, setHoaDueLists}: any) => {

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [listIndex, setListIndex] = useState(null);
	const onDeleteModalClose = () => {
		setIsDeleteModalOpen(false);
	}

	const onDeleteClick = (index: number) => {
		setListIndex(hoaDueList.indexOf(index));
		setIsDeleteModalOpen(true);
	}

	const onUpdateClick = (item: any) => {
		setUpdateIndex(hoaDueList.indexOf(item))
		setIsAddOrUpdateModalOpen(true);
		setHoaDue(item);
	}

	const handleDelete = async () => {
		let hoaDueListCopy = JSON.parse(JSON.stringify(hoaDueList));
		if(Array.isArray(hoaDueListCopy) && listIndex < hoaDueListCopy.length) {
			hoaDueListCopy[listIndex].isDeleted = true;
			setHoaDueLists(hoaDueListCopy);
		}
		onDeleteModalClose();
	}
    if(isHoaDueLoading){
        return(
            <Stack direction='column' spacing={1}>
                <Skeleton variant="rectangular"  height={92} />
                <Skeleton variant="rectangular"  height={92} />
            </Stack>
        )
    }
	return (
		<Stack>
			{
				list && list.length > 0 ? list.map((item: any, index: number) => {
					if(!item.isDeleted){
						return (
						<Card
							variant="outlined"
							style={{ background: "#FAFAFA" }}
							className="violation-card-container"
						>
							<Stack direction={"row"} justifyContent={'space-between'}>
								<div style={{display:'flex', cursor: 'pointer'}} onClick={()=>onUpdateClick(item)}>
									<span style={{marginRight: '12px', color: '#9F9F9F'}}>{index+1}</span>
									<div style={{display: 'flex', flexDirection: 'column'}}>
										<span>{`${item.invoiceDetails} - $${item.invoiceAmount}`}</span>
										<span style={{fontSize: '14px',color: '#9F9F9F', paddingTop: '8px'}}>ID : {item.objectId ? `${item.propertyId}-${item.objectId}` : 'N/A'}</span>
										<span style={{fontSize: '14px',color: '#9F9F9F', paddingTop: '8px'}}>Added On : {item.createdAt ? new Date(item.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'N/A'}</span>
									</div>
								</div>
								<div style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: item?.isHighPriority ? 'flex-end' : 'center',
										justifyContent: item?.isHighPriority ? 'space-between' : 'center',
									}}>
									{item?.isHighPriority && (
										<Box sx={{
											fontSize: '12px',
											p: '5px',
											background: '#eccbc6',
											color: '#c05142',
											borderRadius: '4px'
										}}>
											High Priority
										</Box>
										)}
										<IconButton style={{ cursor: 'pointer' }} onClick={() => onDeleteClick(item)}>
											<DeleteOutlineIcon />
										</IconButton>
									</div>
							</Stack>
						</Card>
						)
					}
				}) :
				<Card
					variant="outlined"
					style={{ background: "#FAFAFA" }}
					className="violation-card-container"
				>
					<Stack direction={"row"} justifyContent={'space-between'}>
						<div style={{display:'flex'}}>
							<span style={{marginRight: '12px', color: '#9F9F9F'}}>{`No Item Added Yet !`}</span>
						</div>
					</Stack>
				</Card>
			}
			<HoaPropertyViolationDeleteListItem open={isDeleteModalOpen} onClose={onDeleteModalClose} handleDelete={handleDelete} />
		</Stack>
	)
}